import { useState } from 'react';
import { Check, ChevronDown, ChevronRight } from 'lucide-react';
import { UNASSIGNED_STORE } from '../lib/constants.js';

export function StorePreview({ groceries, updateData }) {
  const [openStore, setOpenStore] = useState('');
  const grouped = groceries.reduce((groups, item) => {
    const store = item.store || UNASSIGNED_STORE;
    if (store === UNASSIGNED_STORE) return groups;
    groups[store] = [...(groups[store] || []), item];
    return groups;
  }, {});
  const stores = Object.keys(grouped).sort((a, b) => a.localeCompare(b));
  const toggleStore = (store) => setOpenStore((current) => current === store ? '' : store);
  const completeItem = (id) => {
    updateData((current) => ({
      ...current,
      groceries: current.groceries.map((item) => (
        item.id === id ? { ...item, bought: !item.bought } : item
      ))
    }));
  };
  return (
    <div className="store-preview">
      {stores.length === 0 && <p className="empty-drop-text">No active store lists</p>}
      {stores.map((store) => (
        <section className="preview-store-group" key={store}>
          <button
            className="preview-store-heading"
            onClick={() => toggleStore(store)}
            type="button"
            aria-expanded={openStore === store}
          >
            <strong>{store}</strong>
            <span>{grouped[store].filter((item) => !item.bought).length} open</span>
            {openStore === store ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </button>
          {openStore === store && (
            <div className="preview-store-items">
              {grouped[store].map((item) => (
                <div className="preview-store-item" key={item.id}>
                  <button
                    className={item.bought ? 'check-circle checked' : 'check-circle'}
                    onClick={() => completeItem(item.id)}
                    type="button"
                    aria-label={`Check off ${item.name}`}
                  >
                    <Check size={14} />
                  </button>
                  <span>{item.name}</span>
                  {item.price && <small>{item.price}</small>}
                </div>
              ))}
            </div>
          )}
        </section>
      ))}
    </div>
  );
}
